import firebase from "firebase/app"
import "firebase/auth"
import { config } from "../../config"

export const initializeFirebaseApp = () => {
  if (!firebase.apps.length) {
    firebase.initializeApp(config.firebase)
  }
}
